/* global THREE */

import aframe from "aframe";
import { bindEvent, bindEventPlayPause } from "aframe-event-decorators";

// const utils = aframe.utils;

const v1 = new THREE.Vector3();
// const v2 = new THREE.Vector3();
// const q1 = new THREE.Quaternion();

let poolEl;

let nMissile = 0;

aframe.registerComponent("missile", {
  schema: {
    speed: { type: "number", default: 0.5 },
    color: { type: "color", default: "red" },
    distance: { type: "number", default: 4 },
    groundHeight: { type: "number", default: -0.1 },
    timeWarpFactor: { type: 'number', default: 1 },
    isPlayer: { default: false },
    splitAt: { type: "array" }
  },
  init: function () {
    this.nMissile = ++nMissile;
    this._startPosition = this.el.object3D.position.clone();

    if (poolEl === undefined) {
      poolEl = document.querySelector("[mipool__explosion]");
    }
  },
  reset: function () {
    // Reset missile when its fresh from the pool
    this._setVisibleMesh();
    this._startPosition.copy(this.el.object3D.position);
    this._distanceFlown = 0;
    this._isExploding = false;
    this._timeWarpFactor = this.data.timeWarpFactor;
    this.el.getObject3D("mesh").visible = true;
    this.el.setAttribute("meshline", {
      start: "0 0 0",
      end: this.el.object3D.position,
      lineWidth: 0.003,
      color: this.data.color
    });
    this.el.setAttribute("ammo", "count", this.data.splitAt.length);
    this.el.emit("missilespawned", this, true);
  },
  update: function (oldData) {
    if (this.data.isPlayer !== oldData.isPlayer) {
      this._setVisibleMesh();
    }
  },
  tick: function (t, dtm) {
    const dt = dtm / 1000;
    if (this._isExploding === true) {
      this._exploding(dt);
    } else {
      this._flying(dt * this._timeWarpFactor);
    }
  },
  collisionstart: bindEvent(function (evt) {
    if (!this.data.isPlayer && !this._isExploding) {
      this.el.emit("missiledestroyed", this, true);
      this._explode();
    }
  }),
  _flying: function (dt) {
    const forwards = this.el.object3D.getWorldDirection(v1).negate();
    this.el.object3D.position.addScaledVector(forwards, dt * this.data.speed);

    const prevDistanceFlown = this._distanceFlown;
    this._distanceFlown += dt * this.data.speed;
    if (this._distanceFlown > this.data.distance) {
      this._explode(true);
    } else if (this.el.object3D.position.y < this.data.groundHeight) {
      this._explode();
    }

    this.el.setAttribute("meshline", {
      end: `0 0 ${this._distanceFlown}`
    });

    for (let i = 0; i < this.data.splitAt.length; i++) {
      const d = this.data.splitAt[i];
      if (d > prevDistanceFlown && d <= this._distanceFlown) {
        this.el.setAttribute(
          "ammo",
          "count",
          this.el.getAttribute("ammo").count - 1
        );
        this.system.split(this.el, {
          speed: this.data.speed,
          color: this.data.color,
          isPlayer: this.data.isPlayer,
          timeWarpFactor: this._timeWarpFactor
        });
      }
    }
  },
  _explode: function (hitTarget = false) {
    this._isExploding = true;
    this._explodeTimer = 0;
    this.el.getObject3D("mesh").visible = false;

    const explosion = poolEl.components.mipool__explosion.requestEntity();
    if (explosion !== undefined) {
      explosion.setAttribute("position", this.el.object3D.position);
      explosion.setAttribute("explosion", {
        color: this.data.color,
        growTime: 1.0,
        fadeTime: 1.0,
        size: 1,
        audioClip: this.data.isPlayer ? "__weak" : hitTarget ? "__heavy" : ""
      });
      explosion.components.explosion.reset();
      explosion.play();
    }

    this.el.emit("missileremoved", this, true);
  },
  _exploding: function (dt) {
    this._explodeTimer += dt;
    if (this._explodeTimer >= 1) {
      this.system.release(this.el);
    }
  },
  _setVisibleMesh: function () {
    this.el.object3D.traverse(o => {
      if (o.name === "player-missile") {
        o.visible = !!this.data.isPlayer;
      } else if (o.name === "enemy-missile") {
        o.visible = !this.data.isPlayer;
      }
    });
  },
  gamestatechanged: bindEventPlayPause({ target: "[game-state]" }, function (
    evt
  ) {
    const newState = evt.detail;
    if (newState !== "Playing") {
      this.system.release(this.el);
    }
  }),
  startTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    if (!this.data.isPlayer)
      this._timeWarpFactor = evt.detail.factor;
  }),
  endTimeWarp: bindEvent({ target: '[game-state]' }, function (evt) {
    this._timeWarpFactor = 1;
  })
});
